var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinColor = function SvgLinkedinColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A66C2",
    fillRule: "evenodd",
    d: "M3.833 22.5h16.334a2.333 2.333 0 0 0 2.333-2.333V3.833A2.333 2.333 0 0 0 20.167 1.5H3.833A2.333 2.333 0 0 0 1.5 3.833v16.334A2.333 2.333 0 0 0 3.833 22.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.583 19.583h-3.116v-5.307c0-1.456-.553-2.269-1.705-2.269-1.253 0-1.908.846-1.908 2.268v5.308H9.851V9.473h3.003v1.361s.903-1.67 3.05-1.67c2.144 0 3.68 1.309 3.68 4.017zM6.268 8.148a1.86 1.86 0 0 1-1.851-1.866c0-1.03.828-1.865 1.851-1.865s1.852.835 1.852 1.865-.829 1.866-1.852 1.866m-1.55 11.435h3.131V9.473H4.718z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedinColor;